import { Flex, Icon, Stack } from '@chakra-ui/react';
import { IconEdit, IconHandStop } from '@tabler/icons';
import { useGlobalContext } from 'contexts/GlobalContext';
import { useHistory } from 'react-router-dom';

export default function EditButton({ row }) {
	const history = useHistory();

	const { pathCompanyName } = useGlobalContext();
	const goToRegister = () => {
		const { cycleId, companyAreaId } = row;
		const page = companyAreaId
			? 'colaboracao/' + row.companyAreaName?.toLowerCase()
			: 'consenso/criar';

		const baseRoute = `/${pathCompanyName}/demanda/${page}`;
		const params = `cycle-id=${cycleId}${
			companyAreaId ? '&company-area-id=' + companyAreaId : ''
		}`;
		history.push(`${baseRoute}?${params}`);
	};
	return (
		<Flex
			cursor='pointer'
			h='max-content'
			w='max-content'
		>
			<Stack
				direction='row'
				alignSelf={{ base: 'unset', md: 'flex-end' }}
				spacing='4px'
			>
				<Icon
					data-test='link-editar'
					as={row.completed ? IconEdit : IconHandStop}
					color={row.completed ? 'secondaryGray.50' : 'red.500'}
					w='20px'
					h='20px'
					onClick={goToRegister}
				/>
			</Stack>
		</Flex>
	);
}
